import { useCreate, useDelete, useDetail, useList, useListInfinite, useUpdate } from "@inmagik/react-crud"
import { API_URL } from "../constants"
import { Assemblaggio, HistoricalInfo } from "../types"

export function useAssemblaggiList(params: Record<string, string> = {}) {
  return useList<Assemblaggio>(`${API_URL}/assemblaggi`, {
    query: params,
  })
}

export function useAssemblaggio(id: number | undefined | string) {
  return useDetail<Assemblaggio>(`${API_URL}/assemblaggi`, id?.toString())
}

export function useAssemblaggioCreate() {
  return useCreate<Assemblaggio>(`${API_URL}/assemblaggi`)
}

export function useAssemblaggioUpdate() {
  return useUpdate<Assemblaggio>(`${API_URL}/assemblaggi`)
}

export function useAssemblaggioDelete() {
  return useDelete<Assemblaggio>(`${API_URL}/assemblaggi`)
}

export function useAssemblaggioHistory(id: number | string) {
  return useListInfinite<HistoricalInfo>(`${API_URL}/assemblaggi/${id}/history`)
}
